import { z } from 'zod';

import {
  isEmailShaped,
  isFreeEmailDomain,
  WORK_EMAIL_ERROR
} from '@/shared/utils/workEmail';

export const buildRequestAccessSchema = (maxColleagues: number) =>
  z.object({
    email: z
      .string()
      .min(1, 'Email is required')
      .email('Must be a valid email address')
      .refine((value) => !isFreeEmailDomain(value), WORK_EMAIL_ERROR),
    companyName: z.string().min(1, 'Company name is required'),
    colleagueEmails: z
      .array(
        z.object({
          // A revealed-but-untouched colleague field must not block submit, so
          // empty is valid here and stripped before the request goes out.
          value: z
            .string()
            .trim()
            .refine(
              (value) => value === '' || isEmailShaped(value),
              'Must be a valid email address'
            )
        })
      )
      .max(maxColleagues)
  });

export type RequestAccessFormData = z.infer<
  ReturnType<typeof buildRequestAccessSchema>
>;
